import type { CategoryViewProps } from '../../types';
import * as React from 'react';
import { CollectionD as CollectionComponent } from '../../containers/CollectionD';

export function View(props: CategoryViewProps) {
  return (
    <>
      <CollectionComponent {...props} />
    </>
  );
}
